import ReducerUtils                   from "../../../utils/ReducerUtils"
import Actions                        from "../../../model/constant/actions"

const TryingMoveProxySimulation = ReducerUtils.createReducer<boolean>(false,{
  [Actions.TRYING_PROXY_MOVE_SIMULATION] : (state,action) => action.status
})

export default TryingMoveProxySimulation
